import React from "react";
import {ListItem, ListItemProps} from "@mui/material";
import * as ST from "./styled";

interface SubMenuItemProps extends ListItemProps {}

const SubMenuItem: React.FC<SubMenuItemProps> = (props) => {
	return <ListItem sx={ST.ListItemStyles} {...props} />
}

export default SubMenuItem